namespace Gamification.Gamification {
    export class ProdottiEsperienzeTaskEditorColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzeTaskEditor';
    }
}
